module.exports = __webpack_public_path__ + "media/images/Checkmark-f18404e69b353d1d4f221d9bba92d8ae.png";